import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPng = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 0.5H11.793L15.5 4.207V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5C4.948 15.5 4.5 15.052 4.5 14.5V1.5C4.5 0.948 4.948 0.5 5.5 0.5Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.788 0.5L15.5 4.223V4.5H11.5V0.5H11.788Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 14,
			height: 8,
			rx: 1.5,
			fill: "#A966BE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.748 11.9C11.522 12.039 11.243 12.109 10.913 12.109C10.37 12.109 9.925 11.92 9.578 11.544C9.216 11.165 9.035 10.648 9.035 9.991C9.035 9.327 9.218 8.795 9.583 8.394C9.949 7.994 10.432 7.793 11.033 7.793C11.554 7.793 11.972 7.926 12.288 8.191C12.605 8.454 12.787 8.784 12.833 9.179H11.99C11.925 8.899 11.766 8.703 11.514 8.592C11.373 8.531 11.216 8.5 11.044 8.5C10.714 8.5 10.442 8.625 10.229 8.876C10.017 9.124 9.912 9.499 9.912 10C9.912 10.504 10.027 10.861 10.257 11.071C10.487 11.28 10.748 11.385 11.041 11.385C11.329 11.385 11.564 11.303 11.748 11.138C11.932 10.971 12.045 10.753 12.087 10.484H11.139V9.799H12.847V12H12.279L12.193 11.488C12.028 11.683 11.88 11.82 11.748 11.9Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.374 12H7.517L5.843 9.087V12H5.044V7.899H5.943L7.576 10.762V7.899H8.374V12Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.942 10.525H2.071V12H1.22V7.899H3.006C3.418 7.899 3.746 8.005 3.991 8.216C4.236 8.428 4.358 8.755 4.358 9.198C4.358 9.682 4.236 10.025 3.991 10.225C3.746 10.425 3.397 10.525 2.942 10.525ZM3.343 9.671C3.454 9.573 3.51 9.417 3.51 9.204C3.51 8.991 3.453 8.838 3.34 8.748C3.229 8.657 3.072 8.611 2.87 8.611H2.071V9.819H2.87C3.072 9.819 3.23 9.77 3.343 9.671Z",
			fill: "white"
		})
	]
});
export default SvgPng;
